import styled from '@emotion/styled';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { useTranslate } from '@tolgee/react';

/**
 * 企业版汇总：仅展示扫码联系，不展示价格信息（对齐 perseus 企业定制卡口径：
 * 点选后汇总仅展示扫码联系，不走线上下单）
 */
export const EnterpriseTotal = () => {
  const { payQrcode } = useFlagConfigValue();
  const { t } = useTranslate();

  return (
    <EnterpriseContainer>
      <img src={payQrcode} alt="Pay" />
      <strong>{t('market.咨询更多企业版服务详情，扫码添加客户服务专家')}</strong>
    </EnterpriseContainer>
  );
};

const EnterpriseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 0;
  background: var(--fett-erp-card-bg);
  color: var(--fett-text-secondary);
  text-align: center;

  & > img {
    width: 160px;
    height: 160px;
  }
`;
